import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  title: theme.title,
  paper: {
    '&.MuiPaper-rounded': { borderRadius: '30px' },
  },
  container: {
    justifyContent: 'center',
  },
}));

const PopUpMessage = ({
  handleClose,
  handleOpen,
  open,
  children,
  title,
  content,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={classes.paper}
    >
      <DialogTitle id="alert-dialog-title" className={classes.title}>
        {title}
      </DialogTitle>
      <DialogContent>
        <Typography>{content}</Typography>
      </DialogContent>
      <DialogActions className={classes.container}>{children}</DialogActions>
    </Dialog>
  );
};

PopUpMessage.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func,
  handleOpen: PropTypes.func,
  children: PropTypes.node,
  title: PropTypes.string,
  content: PropTypes.string.isRequired,
};

export default PopUpMessage;
